import { render, staticRenderFns } from "./InventoryHistoryRecord.vue?vue&type=template&id=28353d7c&scoped=true"
import script from "./InventoryHistoryRecord.vue?vue&type=script&lang=js"
export * from "./InventoryHistoryRecord.vue?vue&type=script&lang=js"
import style0 from "./InventoryHistoryRecord.vue?vue&type=style&index=0&id=28353d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28353d7c",
  null
  
)

export default component.exports